/** Bildirishnomalar. Kalitlar ["notifications", ...] -- real-time mijoz shu kalitni yangilaydi. */
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type Paginated } from "@/lib/api";

export interface Notification {
  id: number;
  kind: string;
  title: string;
  body: string;
  link: string;
  read_at: string | null;
  created_at: string;
}

export const notificationKeys = {
  all: ["notifications"] as const,
  list: (unreadOnly: boolean, page: number) => ["notifications", "list", unreadOnly, page] as const,
};

export function useNotifications(unreadOnly: boolean, page = 1, pageSize = 25) {
  return useQuery({
    queryKey: [...notificationKeys.list(unreadOnly, page), pageSize],
    queryFn: () =>
      api.get<Paginated<Notification>>("/api/notifications/", {
        query: { unread: unreadOnly ? 1 : undefined, page, page_size: pageSize },
      }),
    placeholderData: keepPreviousData,
  });
}

function invalidate(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: notificationKeys.all });
  qc.invalidateQueries({ queryKey: ["counts"] });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post<Notification>(`/api/notifications/${id}/read/`),
    onSuccess: () => invalidate(qc),
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ updated: number }>("/api/notifications/read-all/"),
    onSuccess: () => invalidate(qc),
  });
}

/** O'qilmagan deb qaytarish (o'ng tugma menyusi) */
export function useMarkUnread() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post<Notification>(`/api/notifications/${id}/unread/`),
    onSuccess: () => invalidate(qc),
  });
}
